<template>
    <div
        :class="classObject"
        class="avatar round-image"
        @click="$emit('click')"
    >
        <img
            v-if="avatarUrl"
            :src="`/storage/${avatarUrl}`"
        >
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        round: {
            type: Boolean,
            default: true,
        },

        size: {
            type: String,
            default: null,
        },
    },

    computed: {
        ...mapGetters(['avatarUrl']),

        /**
         * Return class object.
         *
         * @returns {object} Class object.
         */
        classObject() {
            const sizeClass = `size-${this.size}`;

            return {
                'is-empty': ! this.avatarUrl,
                'is-round': this.round,
                'is-clickable': this.$listeners && this.$listeners.click,
                [sizeClass]: !! this.size,
            };
        },
    },

};
</script>
